<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [class.active]="isActive">
    <g id="icon lock">
        <path id="frame" fill-rule="evenodd" clip-rule="evenodd"
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill="var(--bubble-bg)"/>
        <g id="icon32/lock">
            <g id="Group 700">
                <path id="bottom"
                      d="M9.5 16.5H14.5C15.6046 16.5 16.5 15.6046 16.5 14.5V12C16.5 10.8954 15.6046 10 14.5 10H9.5C8.39543 10 7.5 10.8954 7.5 12V14.5C7.5 15.6046 8.39543 16.5 9.5 16.5Z"
                      stroke="var(--bubble-color)"/>
                <path id="bottom_2"
                      d="M14.5 10.5V8C14.5 6.61929 13.3807 5.5 12 5.5V5.5C10.6193 5.5 9.5 6.61929 9.5 8V10.5"
                      stroke="var(--bubble-color)"/>
                <circle id="dot" cx="12" cy="13" r="1" fill="var(--bubble-color)"/>
                <path id="Vector 493" d="M12 13V15" stroke="var(--bubble-color)"/>
            </g>
        </g>
    </g>
</svg>
